import { render } from "./ContactRole.vue?vue&type=template&id=82d6d4c8"
import script from "./ContactRole.vue?vue&type=script&lang=js"
export * from "./ContactRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__